__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/27c3b61fe0fb9e01575c561c631b559189827aba63dc26e538e5d65f/";